// src/pages/ForgotPassword.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ForgotPassword() {
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent]       = useState(false);
  const [error, setError]     = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ email }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Something went wrong');
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logoWrap}>
          <img src="/logo.png" alt="TraderAIgo" style={styles.logo} />
        </div>
        <h1 style={styles.title}>TraderAIgo</h1>
        <h2 style={styles.subtitle}>Forgot Password</h2>

        {sent ? (
          <div style={styles.success}>
            <p style={{ margin: 0 }}>
              ✅ If that email is registered, you'll receive a reset link shortly.
              Check your inbox (and spam folder).
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={styles.form}>
            <p style={styles.hint}>
              Enter your account email and we'll send you a link to reset your password.
            </p>

            <label style={styles.label}>Email address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="you@example.com"
              style={styles.input}
            />

            {error && <div style={styles.error}>{error}</div>}

            <button type="submit" disabled={loading} style={styles.button}>
              {loading ? 'Sending…' : 'Send Reset Link'}
            </button>
          </form>
        )}

        <p style={styles.footer}>
          Remembered your password?{' '}
          <Link to="/login" style={styles.link}>Sign In</Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f0f2f5',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: '2.5rem 2rem',
    width: '100%',
    maxWidth: 400,
    boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
  },
  logoWrap: { textAlign: 'center', marginBottom: '0.5rem' },
  logo: { width: 52, height: 52, objectFit: 'contain', borderRadius: 10 },
  title: {
    margin: '0 0 0.25rem',
    fontSize: '1.6rem',
    color: '#1976d2',
    textAlign: 'center',
  },
  subtitle: {
    margin: '0 0 1.5rem',
    fontSize: '1.1rem',
    color: '#555',
    textAlign: 'center',
    fontWeight: 400,
  },
  hint: {
    margin: '0 0 1rem',
    fontSize: '0.9rem',
    color: '#555',
    lineHeight: 1.5,
  },
  form: { display: 'flex', flexDirection: 'column', gap: '0.5rem' },
  label: { fontSize: '0.85rem', color: '#444', fontWeight: 600, marginTop: '0.25rem' },
  input: {
    padding: '0.65rem 0.75rem',
    fontSize: '1rem',
    border: '1px solid #ccc',
    borderRadius: 6,
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  error: {
    color: '#c62828',
    backgroundColor: '#ffebee',
    border: '1px solid #ef9a9a',
    borderRadius: 6,
    padding: '0.5rem 0.75rem',
    fontSize: '0.9rem',
  },
  success: {
    backgroundColor: '#e8f5e9',
    border: '1px solid #a5d6a7',
    borderRadius: 8,
    padding: '1rem',
    color: '#2e7d32',
    fontSize: '0.92rem',
    lineHeight: 1.5,
  },
  button: {
    marginTop: '1rem',
    padding: '0.75rem',
    backgroundColor: '#1976d2',
    color: '#fff',
    border: 'none',
    borderRadius: 6,
    fontSize: '1rem',
    fontWeight: 600,
    cursor: 'pointer',
  },
  footer: {
    marginTop: '1.5rem',
    textAlign: 'center',
    fontSize: '0.9rem',
    color: '#666',
  },
  link: { color: '#1976d2', textDecoration: 'none', fontWeight: 600 },
};
